module.exports = __webpack_public_path__ + "static/img/home-img5.6d8e741.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/home-img5.png
// module id = Si6U
// module chunks = 1